export default __webpack_public_path__ + "static/media/graf-banner-why-revert.f9a50094.svg";